import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ImageCarouselData {
  images: { name: string; url: string; savedAt?: any; path?: string }[];
  initialIndex: number;
}

@Component({
  selector: 'app-image-carousel-dialog',
  templateUrl: './image-carousel-dialog.component.html',
  styleUrls: ['./image-carousel-dialog.component.scss']
})
export class ImageCarouselDialogComponent {
  currentIndex: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ImageCarouselDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageCarouselData
  ) {
    this.currentIndex = data.initialIndex || 0;
  }

  nextImage() {
    if (this.currentIndex < this.data.images.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // wrap around
    }
  }

  prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.data.images.length - 1; // wrap around
    }
  }

  close() {
    this.dialogRef.close();
  }
}
